/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Vat_HintInputs */

const vi_einvoice_draft_vat_hint = /** @type {(inputs: Einvoice_Draft_Vat_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi chiết khấu sẽ gợi ý lại VAT theo thuế suất. Bạn có thể chỉnh tiền VAT đến từng đồng; đổi tên hàng hoặc ngày sẽ giữ tiền VAT đã nhập.`)
};

/**

* @param {Einvoice_Draft_Vat_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_vat_hint = /** @type {((inputs?: Einvoice_Draft_Vat_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Vat_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_vat_hint(inputs)
});